import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';
import styles from './barChart1.module.css';
import * as echarts from 'echarts';
import {getHzDzRankingXueqiRequest} from "../../../service/report";
import {getBadgeListRequest} from "../../../service/user";
import PubSub from "pubsub-js";
var myLineChart = null;

class BarChart1 extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, [
            'initLineBar'
        ]);

        this.state = {
            paiming:'',
            badgeMineNum:'',
            badgeAverageNum:'',
            badgeMaxNum:''
        };

    }

    componentDidMount() {

        getHzDzRankingXueqiRequest(sessionStorage.getItem('studentpid'), (data) => {
            console.log(data)

            PubSub.publish('barChart11Update',data)

            if(data.ret=='1'){
                this.setState({
                    badgeMineNum:data.data.student_hz_dz.badge,
                    badgeAverageNum:data.data.class_avg.bavg,
                    badgeMaxNum:data.data.class_avg.bmax,
                    paiming:data.data.student_hz_dz.bpm
                });

                var bavg = parseFloat(data.data.class_avg.bavg).toFixed(2);

                var xzdata =  [data.data.class_avg.bmax,bavg,data.data.student_hz_dz.badge];
                this.initLineBar(xzdata);

            }
        });

    }

    componentDidUpdate() { // 组件更新后触发


    }

    componentWillUnmount (){
        myLineChart.dispose();
    }

    initLineBar(data) {
        const colors = ['#e76e9b','#1bb2e1','#a156cd' ];

        var xzdata =  data;
        var yzdata = ['班级最高', '班级平均','我的徽章'  ];

        var option = {
            tooltip: {
                show:false,
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            grid: {
                top:'0%',
                left: '5%',
                bottom: '2%',
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                position: 'top',
                axisLine:{
                    lineStyle:{
                        color:"#fff",
                        width:1,
                    }
                },
                splitLine: {     //网格线
                    "show": false
                },
                axisLabel:{
                    show:false
                },

            },
            yAxis: {
                type: 'category',
                data: yzdata,
                axisLine:{
                    show:false,
                    lineStyle:{
                        color:'#3291d3',
                        width:1,
                    }
                },
                axisTick:{
                    show: false //不显示坐标轴刻度线
                },
                axisLabel: {
                    margin: 10,
                    textStyle: {
                        color: '#3291d3',
                        fontSize: 16,//字体大小
                    },
                },

            },
            series: [
                {
                    type: 'bar',
                    data: xzdata,
                    label: {   //设置柱状图上显示  对应值
                        show: true,
                        position: 'right',
                        color:'#3291d3',
                        textStyle: {
                            fontSize: 16,//字体大小
                        },
                    },
                    barWidth : 20,
                    // barGap:'10%',
                    // // barCategoryGap:'10%',

                    itemStyle: {
                        normal: {
                            color: function(params) {   // 设置前三个颜色不一样
                                var num = params.value;
                                var djg = params.dataIndex;   //第几个数

                                return colors[params.dataIndex]
                            },
                            barBorderRadius: [15, 15, 15, 15] // 设置柱状图圆角（顺时针左上，右上，右下，左下）
                        },

                    },
                },
            ]
        };


        myLineChart = echarts.init(document.getElementById('barChart11'));
        myLineChart.setOption(option, true)

    }


    render() {

        return (
            <div className={styles.root} id='bar'>
                <div className={styles["div-title"]}>
                    <div className={styles["text-green"]}>徽章班级排名</div>
                    <div className={styles["text-red"]}>{this.state.paiming}</div>
                </div>
                <div id="barChart11" className={styles.echart} ></div>

            </div>
        )
    }
}


export default BarChart1;
